"use client";

import { cn } from "@/lib/utils";
import React from "react";
import { IoMdPlay, IoMdPause, IoMdClose } from "react-icons/io";
import { BiFullscreen } from "react-icons/bi";

export interface ButtonIconsProps
  extends React.HTMLAttributes<HTMLButtonElement> {
  className?: string;
  type: "play" | "pause" | "close" | "fullscreen";
  size: "sm" | "lg";
  onClick?: () => void;
}

const ButtonIcons: React.FC<ButtonIconsProps> = ({
  type = "play",
  size = "lg",
  className = "",
  onClick,
  ...props
}) => {
  return (
    <button
      className={cn(
        "items-center justify-center rounded-full bg-neutral-500 text-center text-white hover:bg-white hover:text-neutral-500",
        size === "lg" && "size-14",
        size === "sm" && "size-8",
        className
      )}
      onClick={onClick}
      {...props}
    >
      <span>{getIcon(type, size)}</span>
    </button>
  );
};

function getIcon(type: string, size: "sm" | "lg") {
  switch (type) {
    case "play":
      return (
        <IoMdPlay
          className={cn(
            "mx-auto",
            size === "lg" && "pl-1",
            size === "sm" && "pl-0.5"
          )}
          size={size === "lg" ? 28 : 16}
        />
      );
    case "pause":
      return (
        <IoMdPause
          className={cn("mx-auto")}
          size={size === "lg" ? 28 : 16}
        />
      );
    case "close":
      return (
        <IoMdClose
          className={cn("mx-auto")}
          size={size === "lg" ? 42 : 24}
        />
      );
    case "fullscreen":
      return (
        <BiFullscreen
          className={cn("mx-auto")}
          size={size === "lg" ? 36 : 22}
        />
      );
  }
}

export default ButtonIcons;
